module.exports = __webpack_public_path__ + "assets/index-tishi.7af69fb1eeabd1b293beb1ecee3a2c41.png";